var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTravelerStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 120"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1BB2C5",
    d: "M108 24a6 6 0 016 6v72a6 6 0 01-3.06 5.16l-2.94 1.68V108H96V24h12zm-84 0v84H12a6 6 0 01-6-6V30a6 6 0 016-6h12zM75 0H45a3 3 0 00-3 3v15H12A12 12 0 000 30v72a12 12 0 0012 12v1.5a4.56 4.56 0 004.5 4.5h3a4.56 4.56 0 004.5-4.5V114h78v1.5a4.56 4.56 0 004.5 4.5h3a4.56 4.56 0 004.5-4.5v-3a12 12 0 006-10.5V30a12 12 0 00-12-12H78V3a3 3 0 00-3-3zM48 18V6h24v12H48zm-18 90V24h60v84H30zm22.62-43.38l14.64 3.42-1.14 5.22-14.58-3.48 1.08-5.16zm-1.74-6.54a3.72 3.72 0 00-3.6 2.88l-2.1 9.78a3.66 3.66 0 002.7 4.32l19.2 4.56h.84a3.66 3.66 0 003.54-2.88l2.16-9.78a3.66 3.66 0 00-2.76-4.32L51.72 58.2h-.84v-.12zM75 48a3 3 0 110 6 3 3 0 010-6zm0-6a9 9 0 100 18 9 9 0 000-18z",
    opacity: 0.15
  })));
}

export default SvgTravelerStroke;